import type { FaireProductEntity } from "../../entity_types/product";

export const p_6hpsn5r7ef: FaireProductEntity = {
  token: "p_6hpsn5r7ef",
  type: "product",
  name: "Soul Eater, Vol. 23",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/df0ae6ff4f92ed14df8729f8c7adcf1e06db9cb0ffd0c5355dd1bb48326f7328.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.5,
  description: "Kid enters the witches' realm to appeal for help! Though they have been DWMA's enemies for years, the witches share a respect for order--and are equally threatened by the Kishin. Kid's immediate goal is to deal with the situation on the moon, but he hopes that the negotiations will forge a new pact between DWMA and witches in the future--assuming anyone survives the Kishin's madness!\n",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:34.292Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
